module.exports = __webpack_public_path__ + "static/media/arrow_open.01e00494.svg";